
<footer>
    <!--
    Kuaa. &copy; All rights reserved 2021 
    -->
</footer>
